import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import type { AuthUser } from "@aurelia/types";
import { apiFetch } from "../../lib/api-client";
import { useAuthStore } from "../../lib/stores/auth";

export function useBootstrapAuth() {
  const setUser = useAuthStore((s) => s.setUser);
  const { data, isError, isFetched } = useQuery({
    queryKey: ["me"],
    queryFn: () => apiFetch<{ user: AuthUser }>("/auth/me"),
    retry: false
  });

  useEffect(() => {
    if (!isFetched) return;
    setUser(isError ? null : data?.user ?? null);
  }, [isFetched, isError, data, setUser]);
}
